import { Ikone } from "../Ikone.tsx";

/**
 * Die Fehlermeldungen gescheiterter Uploads (Task 4, "Uploads bis 100 MB"): eine Zeile je Meldung,
 * bis der Nutzer sie schliesst. Anders als der Toast (`App/Toast.tsx`, 2,2 Sekunden) bleibt sie
 * stehen - ein Upload von 100 MB, der nach Minuten scheitert, darf nicht in einem Augenblick
 * verschwinden, in dem niemand hinsieht. Die Texte liefert `lib/upload.ts#uploadFehlerText`.
 *
 * Reine Anzeige: die Liste gehoert dem Aufrufer (Task 5 bis 7), `onSchliessen` leert sie. Bei
 * leerer Liste wird nichts gerendert. `role="alert"`: eine neu erscheinende Meldung wird sofort
 * angesagt.
 */
export interface UploadFehlerAnzeigeProps {
  meldungen: readonly string[];
  onSchliessen: () => void;
}

export function UploadFehlerAnzeige({ meldungen, onSchliessen }: UploadFehlerAnzeigeProps) {
  if (meldungen.length === 0) return null;
  return (
    <div className="upload-fehler" role="alert">
      <div className="upload-fehler-zeilen">
        {meldungen.map((meldung, index) => (
          <p key={`${index}:${meldung}`}>{meldung}</p>
        ))}
      </div>
      <button type="button" className="icon-btn" aria-label="Meldung schließen" onClick={onSchliessen}>
        <Ikone name="x" />
      </button>
    </div>
  );
}
